/**
 * @generated SignedSource<<385046e0ead0a81965376106d8167607>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationEndDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stopId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "stopId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Route",
  "kind": "LinkedField",
  "name": "routes",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "types",
      "value": [
        "STOP",
        "ROUTES"
      ]
    }
  ],
  "concreteType": "Alert",
  "kind": "LinkedField",
  "name": "alerts",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertDescriptionText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertEffect",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertHeaderText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertSeverityLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveEndDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "effectiveStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "entities",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v10/*: any*/),
            (v9/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v4/*: any*/)
          ],
          "type": "Route",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v4/*: any*/),
            (v8/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vehicleMode",
              "storageKey": null
            }
          ],
          "type": "Stop",
          "abstractKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "alerts(types:[\"STOP\",\"ROUTES\"])"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRoutes_StopDisruptions_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "stop",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cancelationEndDate",
                "variableName": "cancelationEndDate"
              },
              {
                "kind": "Variable",
                "name": "cancelationStartDate",
                "variableName": "cancelationStartDate"
              }
            ],
            "kind": "FragmentSpread",
            "name": "DisruptionsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "stopRoutes_StopDisruptions_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "stop",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "end",
                        "variableName": "cancelationEndDate"
                      },
                      {
                        "kind": "Variable",
                        "name": "start",
                        "variableName": "cancelationStartDate"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "timeRanges.0"
                  }
                ],
                "kind": "ListValue",
                "name": "timeRanges"
              }
            ],
            "concreteType": "StopCallOnTripOnServiceDate",
            "kind": "LinkedField",
            "name": "canceledCalls",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TripOnServiceDate",
                "kind": "LinkedField",
                "name": "tripOnServiceDate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tripHeadsign",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pattern",
                        "kind": "LinkedField",
                        "name": "pattern",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Stop",
                            "kind": "LinkedField",
                            "name": "stops",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v4/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "headsign",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Route",
                        "kind": "LinkedField",
                        "name": "route",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StopCall",
                "kind": "LinkedField",
                "name": "stopCall",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "stopLocation",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "type": "Stop",
                        "abstractKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CallSchedule",
                    "kind": "LinkedField",
                    "name": "schedule",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "time",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "departure",
                                "storageKey": null
                              }
                            ],
                            "type": "ArrivalDepartureTime",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "63066f2e3fe94fcd60fe88ca1b5673c9",
    "id": null,
    "metadata": {},
    "name": "stopRoutes_StopDisruptions_Query",
    "operationKind": "query",
    "text": "query stopRoutes_StopDisruptions_Query(\n  $stopId: String!\n  $cancelationStartDate: OffsetDateTime!\n  $cancelationEndDate: OffsetDateTime!\n) {\n  stop(id: $stopId) {\n    ...DisruptionsFragment_4gwf7I\n    id\n  }\n}\n\nfragment DisruptionsFragment_4gwf7I on Stop {\n  gtfsId\n  locationType\n  routes {\n    gtfsId\n    id\n  }\n  canceledCalls(timeRanges: [{start: $cancelationStartDate, end: $cancelationEndDate}]) {\n    tripOnServiceDate {\n      serviceDate\n      trip {\n        tripHeadsign\n        pattern {\n          code\n          stops {\n            name\n            gtfsId\n            id\n          }\n          headsign\n          id\n        }\n        route {\n          gtfsId\n          type\n          color\n          mode\n          shortName\n          id\n        }\n        id\n      }\n    }\n    stopCall {\n      stopLocation {\n        __typename\n        ... on Stop {\n          gtfsId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      schedule {\n        time {\n          __typename\n          ... on ArrivalDepartureTime {\n            departure\n          }\n        }\n      }\n    }\n  }\n  stops {\n    id\n    gtfsId\n    routes {\n      gtfsId\n      id\n    }\n    alerts(types: [STOP, ROUTES]) {\n      id\n      alertDescriptionText\n      alertHash\n      alertEffect\n      alertHeaderText\n      alertSeverityLevel\n      alertUrl\n      effectiveEndDate\n      effectiveStartDate\n      entities {\n        __typename\n        ... on Route {\n          color\n          type\n          mode\n          shortName\n          gtfsId\n        }\n        ... on Stop {\n          gtfsId\n          name\n          locationType\n          vehicleMode\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  alerts(types: [STOP, ROUTES]) {\n    id\n    alertDescriptionText\n    alertHash\n    alertEffect\n    alertHeaderText\n    alertSeverityLevel\n    alertUrl\n    effectiveEndDate\n    effectiveStartDate\n    entities {\n      __typename\n      ... on Route {\n        color\n        type\n        mode\n        shortName\n        gtfsId\n      }\n      ... on Stop {\n        gtfsId\n        name\n        locationType\n        vehicleMode\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "55c652673a97a4118d0dcb59c1f9bd16";

export default node;
